import TranslationText from '@Components/Utilities/TranslationText';

const MyInvoicesView = (props) => {


    return (
        <div className='my-invoices-container'>
            <h3>All transactions and invoicing are facilitated through the auctioneer/dealer. Please contact the auctioneer/dealer for any invoiced items to process further.</h3>

        </div>
    );
}

export default MyInvoicesView;
global.MyInvoicesView = MyInvoicesView;